import { LOGOUT_REQUEST } from '@sit/client-shared';
import { handleActions } from 'redux-actions';
import * as TimesheetRowsTypes from '../TimesheetRows/types';
import * as types from './types';

const initialState = {};

const resetAutofill = () => {
  return initialState;
};

const setAutofill = (state, payload) => {
  const { a, rowId, from } = payload.data;
  if (!rowId) {
    return state;
  }
  const { dimensionId, fixedDimension } = a;
  if (fixedDimension) {
    const prevValues = state[rowId] ? state[rowId][fixedDimension] || [] : [];
    const alreadyAdded = prevValues.find((v) => {
      return v.allowOverride === a.allowOverride && v.order === (a.order || 0) && v.valueId === a.valueId;
    });
    if (alreadyAdded) {
      return state;
    }
    return {
      ...state,
      [rowId]: {
        ...state[rowId],
        [fixedDimension]: [
          {
            allowOverride: a.allowOverride,
            order: a.order || 0,
            valueId: a.valueId,
            from,
          },
          ...prevValues,
        ],
      },
    };
  } else {
    const prevValues = state[rowId] ? state[rowId][dimensionId] || [] : [];
    const alreadyAdded = prevValues.find((v) => {
      return v.allowOverride === a.allowOverride && v.order === (a.order || 0) && v.valueId === a.valueId;
    });
    if (alreadyAdded) {
      return { ...state };
    }
    return {
      ...state,
      [rowId]: {
        ...state[rowId],
        [dimensionId]: [
          {
            allowOverride: a.allowOverride,
            order: a.order || 0,
            valueId: a.valueId,
            from,
          },
          ...prevValues,
        ],
      },
    };
  }
};

const removeRow = (state, payload) => {
  const _state = { ...state };
  delete _state[payload.data.rowId];
  return _state;
};

const removeAutofillValue = (state, payload) => {
  const { from, rowId } = payload.data;

  if (!rowId || !from) {
    return { ...state };
  }
  if (!state[rowId]) {
    return { ...state };
  }
  // Search every dimension autofills where from === from and delete the autofill data
  const _row = state[rowId];
  const updatedRow = {};
  for (const key of Object.keys(_row)) {
    const newAutofills = _row[key].filter((a) => {
      return a.from !== from;
    });
    updatedRow[key] = newAutofills;
  }
  return {
    ...state,
    [rowId]: updatedRow,
  };
};

const logoutRequest = () => initialState;

export default handleActions(
  {
    [TimesheetRowsTypes.DELETE_TIMESHEET_ROW_REQUEST_SUCCESS]: removeRow,
    [types.REMOVE_AUTOFILL_ROW]: removeRow,
    [types.REMOVE_AUTOFILL_VALUE]: removeAutofillValue,
    [types.RESET_AUTOFILL]: resetAutofill,
    [types.SET_AUTOFILL]: setAutofill,
    [LOGOUT_REQUEST]: logoutRequest,
  },
  initialState,
);
